// @ts-nocheck
import { useState, useEffect } from 'react';
import { Button, Paper, InputBase, IconButton } from '@mui/material';
import { IconExport, IconSearch } from '../../../../icons/Icon';
import CustomTabPanel from '../../../../components/commonComponent/CustomTabPanel';
import ListData from './ListData';
import { useSelector } from 'react-redux';
import Loader from '../../../../components/loader/Loader';
import * as XLSX from 'xlsx-js-style'
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { headerStyle, daypartStyle, titleStyle } from '../../../../utils/constants';

const FinalKitchenGIVarianceReportDetails: React.FC<{ params: any }> = ({ params }) => {
  const [openIndices, setOpenIndices] = useState<number[]>([0]);  // Initially open the first accordion
  const [searchTerm, setSearchTerm] = useState<string | null>(null);
  const { kitenReportSAPDetails, loading } = useSelector((state: any) => state.varianceReport);
  const [filteredData, setFilteredData] = useState(kitenReportSAPDetails);

  useEffect(() => {
    if (searchTerm) {
      const filteredData = kitenReportSAPDetails?.map((type: any) => ({
        ...type,
        kitchenindentlist: type.kitchenindentlist.filter((kitchen: any) =>
          kitchen.mogname && kitchen.mogname.toLowerCase().includes(searchTerm.toLowerCase().trim()) // Filter by dishname
        ),
      })).filter((type: any) => type.kitchenindentlist.length > 0);

      const allIndices = filteredData?.flatMap((type: any) =>
        type.kitchenindentlist.map((kitchen: any, index: number) =>
          kitchen.mogname && kitchen.mogname.toLowerCase().includes(searchTerm.toLowerCase().trim()) ? index : null
        ).filter((index: any) => index !== null)
      ) || [];

      setFilteredData(filteredData);
      setOpenIndices(allIndices);
    } else {
      setFilteredData(kitenReportSAPDetails); // Show all data if no search term
      setOpenIndices([0]);
    }
  }, [searchTerm, kitenReportSAPDetails]);


  // Handle toggle change
  const handleToggle = (index: number) => {
    setOpenIndices(prevIndices =>
      prevIndices.includes(index) ? prevIndices.filter(i => i !== index) : [index]
    );
  };

  // Expand all sections
  const handleExpandAll = () => {
    const allIndices = filteredData?.flatMap((type: any) =>
      type.kitchenindentlist.map((_: any, index: number) => index)
    ) || [];
    setOpenIndices(allIndices);
  };

  // Collapse all sections
  const handleCollapseAll = () => {
    setOpenIndices([]); // 
  };

  // Handle search submit
  const handleSearchSubmit = (event: React.FormEvent) => {
    event.preventDefault(); // For now just logging the search term
  };

  const handleExport = async () => {
    try {
      if (kitenReportSAPDetails && kitenReportSAPDetails?.length > 0) {
        // Create a new workbook and worksheet
        const workbook = XLSX.utils.book_new();
        kitenReportSAPDetails?.map((menuReport) => {
          let startingIndex = 0;
          let rowIndexes = [{
            index: startingIndex,
            style: 'title'
          }]
          let exportData: any = [
            ...[[`Cilantro Final Kitchen Indent vs SAP GI Variance Report for ${params?.plandate && format(new Date(params?.plandate), 'dd MMM yyyy')}`, ...Array(6).fill('')]],
            ...[[]]
          ];
          startingIndex += 1;
          exportData?.push([[menuReport?.daypartname, ...Array(6).fill('')]])
          startingIndex += 1;
          rowIndexes.push({
            index: startingIndex,
            style: 'daypart'
          })
          exportData.push(['MOG Name', 'Article Number', 'Article Description', 'Requested Theo Qty', 'Requested Revised Qty', 'Requested GI Qty', 'Variance % on Revised vs GI'])
          startingIndex++;
          rowIndexes.push({
            index: startingIndex,
            style: 'header'
          })
          menuReport?.kitchenindentlist?.map((dish) => {
            if (dish?.mogname) {
              exportData?.push([dish?.mogname, dish?.articlenumber, dish?.articledescription,
              `${dish?.requestedtheoqty ?? 0} kg`,
              `${dish?.requestedrevisedtheoqty ?? 0} kg`,
              `${dish?.requestedgiqty ?? 0} kg`,
              dish?.variance
              ])
              startingIndex++;
            }
          })
          exportData?.push([[]])
          startingIndex++;
          const wids = [{ wpx: 200 }, { wpx: 120 }]
          const worksheet = XLSX.utils.aoa_to_sheet(exportData);
          worksheet['!cols'] = [wids[0], wids[1], wids[0], ...Array(3).fill(wids[1])];
          worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } },
          ];
          rowIndexes?.forEach((rowIndex => {
            // Apply the header style to all header cells
            for (let colIndex = 0; colIndex < 8; colIndex++) {
              const cellAddress = XLSX.utils.encode_cell({ r: rowIndex?.index, c: colIndex });
              if (!worksheet[cellAddress]) {
                worksheet[cellAddress] = {};
              }
              switch (rowIndex?.style) {
                case 'title':
                  worksheet[cellAddress].s = titleStyle;
                  break;
                case 'header':
                  worksheet[cellAddress].s = headerStyle;
                  break;
                case 'daypart':
                  worksheet[cellAddress].s = daypartStyle;
                  break;
                default:
                  break;
              }
            }
          }))
          XLSX.utils.book_append_sheet(workbook, worksheet, menuReport?.daypartname);
        })
        XLSX.writeFile(workbook, `Cilantro_Final_Kitchen_Indent_vs_SAP_GI_Variance_Report-${params?.plandate && format(new Date(params?.plandate), 'dd MMM yyyy')}.xlsx`);
        toast("File downloaded successfully!", { type: "success" });
      } else {
        toast("No data is available", { type: "info" });
      }
    } catch (err) {
      console.log(err)
      toast("Some error has occured", { type: "error" });
    }
  }

  return (
    <div className="white-box mb-12">
      <div className="flex justify-content-between align-items-center title-button-wrapper mb-8">
        <div className="flex align-items-center">
          <Paper component="form" className={`search-input mr-12`} onSubmit={handleSearchSubmit}>
            <InputBase
              placeholder="Search APL"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
            />
            <IconButton type="submit" aria-label="search">
              <IconSearch />
            </IconButton>
          </Paper>
        </div>
        <div className="button-wrap flex align-items-center">
          <Button className="link-btn" disableRipple onClick={handleExpandAll}>
            Expand All
          </Button>
          <span className='divider'></span>
          <Button className='link-btn' disableRipple onClick={handleCollapseAll}>
            Collapse All
          </Button>
          <span className="divider"></span>
          <button onClick={() => handleExport()} className="cmenu-btn mr-4">
            <IconExport /> Export
          </button>
        </div>
      </div>

      <div className="inner-contant kitchen-dashboard">
        {filteredData?.length > 0 ? (
          <CustomTabPanel>
            <ListData
              openIndices={openIndices}
              handleToggle={handleToggle}
              data={filteredData}
            />
          </CustomTabPanel>
        ) : (
          <div className='innrBox active'>
            <div className="noData">No data found</div>
          </div>
        )}
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default FinalKitchenGIVarianceReportDetails;
